import React from "react";
import { useEffect } from "react";
import Penolakan from "../../components/Penolakan/Penolakan";

const PenolakanBukuTanah = () => {
  useEffect(() => {
    document.title = "Penolakan BT";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <Penolakan/>
    </div>
  );
};

export default PenolakanBukuTanah;
